import React from "react";
import {
  formatNumWithCommaNairaSymbol,
  lowerCaseWrap,
  trimLongString,
} from "../../../helper";
import Skeleton from "react-loading-skeleton";
import { RavenToolTip } from "@ravenpay/raven-bank-ui";
import { RouteLinks } from "../../../routes/RouteLinks";
import { encrypt2 } from "../../../utils/encrypt";
import RootState from "../../../redux/types";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import smallTerminalImg from "../../../assets/small-bankbox-terminal-img.svg";
import "../../../styles/dashboard/overview/GridViewIndex.css";
import Icons from "../../../assets/icons/icons";
interface ComponentProps {
  dontShowHeaders?: boolean;
}
const GridViewTerminals: React.FC<ComponentProps> = ({ dontShowHeaders }) => {
  const { loading, insights } = useSelector(
    (state: RootState) => state.insights
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      <div className=" bottom-insight-info-box">
              <div className="title-route-page-box">
                {" "}
                <p className="title">Terminals</p>
                {insights?.terminals?.length > 9 && (
                  <div
                    onClick={() => {
                      navigate(RouteLinks?.Terminals);
                    }}
                    className="view-all-box-terminal"
                  >
                    <p className="view-all">View All Terminals</p>
                    <div className="icon-box">
                      <figure className="img-box">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="img"
                        >
                          <path
                            className="dull-bright-filter"
                            d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5"
                            stroke="#002856"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </figure>
                    </div>
                  </div>
                )}
              </div>

              {/* all terminal boxes wrap start */}
              <div
                style={{
                  justifyContent:
                    insights?.terminals?.length < 4
                      ? "flex-start"
                      : "space-between",
                  display:
                    insights?.terminals?.length < 4
                      ? "flex"
                      : "grid",
                }}
                className="all-terminals-boxes-wrap"
              >
                {insights?.terminals?.map((chi: any, idx: any) => {
                  const { tid_label, serial, volume } = chi || {};
                  return (
                    <div
                      key={idx}
                      className="terminal-box-wrap card-bg border-theme"
                      onClick={async () => {
                        const encryptedSerial = await encrypt2(serial ?? "");
                        localStorage?.setItem("takwoski", encryptedSerial);
                        navigate(RouteLinks?.Terminal_details);
                      }}
                      style={{
                        minWidth:
                          "32rem",
                      }}
                    >
                      {/* top serial  box start */}
                      <div className="top-serial-box">
                        <div className="img-terminal">
                          {loading ? (
                            <Skeleton width={35} height={35} circle />
                          ) : (
                            <figure className="img-box">
                              <img
                                src={smallTerminalImg}
                                alt=""
                                className="img"
                              />
                            </figure>
                          )}
                        </div>
                        <div className="terminal-serial-box">
                          {loading ? (
                            <Skeleton
                              width={70}
                              height={17}
                              style={{ marginBottom: ".3rem" }}
                            />
                          ) : (
                            <p className="terminal">
                              {lowerCaseWrap(tid_label) || "---"}
                            </p>
                          )}
                          {loading ? (
                            <Skeleton width={200} height={11} />
                          ) : (
                            <div className="serial grey-white-color tooltip-hover-wrap">
                              Serial •{" "}
                              <span>
                                {serial ? trimLongString(serial, 15) : "---"}
                              </span>
                              {serial?.length > 14 && (
                                <RavenToolTip
                                  color="deep-green-light"
                                  position={`bottom-right`}
                                  text={serial}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* top serial  box end */}
                      {/* bottom box start */}
                      <div className="bottom-value-box grey-bg">
                        {loading ? (
                          <Skeleton width={100} height={22} />
                        ) : (
                          <p className="amount">
                            {formatNumWithCommaNairaSymbol(volume) || "0.00"}
                          </p>
                        )}
                      </div>
                      {/* bottom box end */}
                    </div>
                  );
                })}
              </div>
              {/* all terminal boxes wrap end */}
            </div>
    </>
  );
};

export default GridViewTerminals;
